import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';
import translationModuleName from '../../../translation';

// Controller
import ChangePasswordController from './changePasswordModal.controller';
import template from './changePasswordModal.html';

// Dependencies
import serviceModuleName from '../../../service';

const moduleName = 'recaps.editor.modals.changePassword';
let module = angular.module(moduleName, [
  uiModal,
  translationModuleName,
  serviceModuleName,
]);

module.controller('ChangePasswordController', ChangePasswordController);
module.factory('showChangePasswordModal', ['$uibModal', '$translate', ($uibModal, $translate) => {
  return props => {
    props = props || {};
    const size = props.size || 'lg';
    const modal = $uibModal.open({
      template: template,
      controller: ChangePasswordController,
      controllerAs: 'vm',
      size: size,
      resolve: {
        message: () => props.message || $translate('CHANGE_PASSWORD'),
        title: () => props.title || $translate('CHANGE_PASSWORD'),
      }
    });
    return modal.result;
  };
}]);

export default module;
